import { MapTo } from '@adobe/aem-react-editable-components';
import UserPreferences from './UserPreferences';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import WithAuth from '../../../../lib/hoc/WithAuth/WithAuth';
import { UserPreferencesProps } from './UserPreferences.types';

const RESOURCE_TYPE = 'learning-academy/components/custom/userpreferences';

const EditConfig = {
  emptyLabel: 'User Preferences: Please configure the component',
  isEmpty: () => false,
};

export default MapTo<UserPreferencesProps>(RESOURCE_TYPE)(
  ...WithEmptyPlaceholder(WithAuth(UserPreferences), EditConfig),
);
